import styled from 'styled-components';

const Name = styled.div`
  font-size: 20px;
  color: #e3e2eb;
  margin-bottom: 5px;
`;

export default Name;
